/* baitishk-cart-icon-fix.js
   Fixes the header cart icon "growing" after an AJAX add-to-cart.
   Root cause (vendor assets/module-add-to-cart.js): CartDrawer.renderContents()
   and ProductForm.updateCartDrawer() update the header icon with
     document.getElementById('cart-icon-bubble').innerHTML =
       getSectionInnerHTML(sections['cart-icon-bubble']);
   getSectionInnerHTML() defaults to the ".shopify-section" wrapper, whose
   innerHTML is the ENTIRE <a id="cart-icon-bubble"> anchor -- so an anchor gets
   nested inside the anchor (<a><a>...</a></a>), doubling the wh-44 box and the
   22px SVG, which is why the icon looks bigger until a hard refresh.
   We can't safely hand-edit the 58KB vendor file on a live-tomorrow theme, so we
   repair the DOM after each cart render: unwrap any anchor nested inside
   #cart-icon-bubble (in place, so a freshly patched badge is preserved) and
   de-duplicate the count. Idempotent, reversible, a no-op when already clean,
   and never touches cart line items or totals. */
(function () {
  'use strict';

  function flatten() {
    var outer = document.getElementById('cart-icon-bubble');
    if (!outer) return;
    var guard = 0;
    var innerA = outer.querySelector('a');
    while (innerA && innerA.parentNode && guard++ < 5) {
      var frag = document.createDocumentFragment();
      while (innerA.firstChild) frag.appendChild(innerA.firstChild);
      innerA.parentNode.replaceChild(frag, innerA);
      innerA = outer.querySelector('a');
    }
    var counts = outer.querySelectorAll('.cart-count');
    if (counts.length > 1) {
      var keep = outer.querySelector('.cart-count.bg-sale') || counts[0];
      Array.prototype.forEach.call(counts, function (c) {
        if (c !== keep) c.remove();
      });
    }
  }

  function schedule() {
    clearTimeout(flatten._t);
    flatten._t = setTimeout(flatten, 40);
  }

  ['cart:updated', 'cart:refresh', 'nextsky:cart:added'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  function start() {
    var outer = document.getElementById('cart-icon-bubble');
    if (!outer) return;
    flatten();
    try {
      new MutationObserver(function () {
        if (outer.querySelector('a')) schedule();
      }).observe(outer, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
